export const CONFIG = {
  quotes: {
    quotesPerPage: 15,
  },
  offer: {
    partsPerPage: 15,
  },
  user: {
    usersPerPage: 30,
  },
  discounts: [...Array(21)].map((el, i) => i/100),
};